import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './DashboardYellow.css';
import DashboardCard from '../../components/dashboard/DashboardCard';

const GeneralUserDashboard = () => {
  const { user } = useAuth();
  const [dashboardData, setDashboardData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      setIsLoading(true);
      setError(null);
      try {
        // Simulate API call for dashboard data
        // Replace with actual API call: const response = await axios.get('/api/v1/user/dashboard-summary');
        await new Promise(resolve => setTimeout(resolve, 1500)); // Simulate network delay
        const mockData = {
          subscribedCreatorsCount: 3,
          savedItemsCount: 12,
          recommendedContent: [
            { id: 1, title: 'Introduction to Quantum Computing', creator: 'SciHub' },
            { id: 2, title: 'Advanced Watercolor Techniques', creator: 'ArtFlow' },
          ]
        };
        setDashboardData(mockData);
      } catch (err) {
        console.error("Failed to fetch general user dashboard data:", err);
        setError("Could not load dashboard data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [user]);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>General User Dashboard</h1>
      </header>

      {/* {user && (
        <section className="dashboard-profile">
          <h2>Welcome, {user.full_name || user.username || 'User'}!</h2>
          <p>Email: {user.email}</p>
          {user.user_type && <p>Account Type: {user.user_type.replace('_', ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</p>}
        </section>
      )} */}
      
      {/* Category Icons Row - similar to Image 2 */}
      {/*<div className="category-icons">*/}
      {/*  <CategoryIcon */}
      {/*    name="Art & Design" */}
      {/*    icon="🎨" */}
      {/*    onClick={() => alert('Art & Design category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Photography" */}
      {/*    icon="📷" */}
      {/*    onClick={() => alert('Photography category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Learn" */}
      {/*    icon="🎓" */}
      {/*    onClick={() => alert('Learn category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Journalism" */}
      {/*    icon="📝" */}
      {/*    onClick={() => alert('Journalism category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Lifestyle" */}
      {/*    icon="🌿" */}
      {/*    onClick={() => alert('Lifestyle category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Read" */}
      {/*    icon="📚" */}
      {/*    onClick={() => alert('Read category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Food & Drink" */}
      {/*    icon="🍽️" */}
      {/*    onClick={() => alert('Food & Drink category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Watch" */}
      {/*    icon="👁️" */}
      {/*    onClick={() => alert('Watch category clicked!')}*/}
      {/*  />*/}
      {/*  <CategoryIcon */}
      {/*    name="Listen" */}
      {/*    icon="🎧" */}
      {/*    onClick={() => alert('Listen category clicked!')}*/}
      {/*  />*/}
      {/*</div>*/}

      {isLoading && <div className="loading-message">Loading dashboard data...</div>}
      {error && <div className="error-message alert alert-danger">{error}</div>}

      {dashboardData && !isLoading && !error && (
        <>
          <section className="dashboard-content">
            <DashboardCard
              title="Discover Content"
              description="Explore new and trending content from creators."
              buttonText="Browse All Content"
              buttonAction={() => alert('Navigate to Discover page!')}
              tooltipText="Click to explore trending content from your favorite creators"
              icon="🔍"
              index={0}
            />
            
            <DashboardCard
              title="Subscribed Creators"
              description="See the latest from creators you follow."
              buttonText="My Subscriptions"
              buttonAction={() => alert('Navigate to Subscriptions page!')}
              tooltipText="View updates from creators you've subscribed to"
              icon="👥"
              count={dashboardData.subscribedCreatorsCount}
              index={1}
            />
            
            <DashboardCard
              title="Saved Items"
              description="Access your bookmarked or saved content."
              buttonText="View Saved Items"
              buttonAction={() => alert('Navigate to Saved Items page!')}
              tooltipText="Access content you've saved for later"
              icon="🔖"
              count={dashboardData.savedItemsCount}
              index={2}
            />
          </section>
          
          {/* Added separate section with margin-top for spacing */}
          <section className="dashboard-content" style={{ marginTop: '20px' }}>
            <DashboardCard
              title="Recommended For You"
              description="Content curated just for you based on your interests."
              buttonText="View All Recommendations"
              buttonAction={() => alert('View all recommendations!')}
              tooltipText="Discover new content based on your preferences"
              icon="✨"
              items={dashboardData.recommendedContent}
              index={0} /* Reset index for this section */
            />
          </section>
        </>
      )}
      {!dashboardData && !isLoading && !error && (
        <section className="dashboard-content">
          <DashboardCard
            title="Discover Content"
            description="Explore content from creators based on your interests."
            buttonText="Browse Content"
            buttonAction={() => alert('Browse Content clicked!')}
            tooltipText="Start exploring content tailored to your interests"
            icon="🔍"
            index={0}
          />
          
          <DashboardCard
            title="My Subscriptions"
            description="Manage your subscriptions to content creators."
            buttonText="View Subscriptions"
            buttonAction={() => alert('View Subscriptions clicked!')}
            tooltipText="See all your current subscriptions"
            icon="👥"
            index={1}
          />
          
          <DashboardCard
            title="Get Started"
            description="Complete your profile and discover content that matches your interests."
            buttonText="Complete Profile"
            buttonAction={() => alert('Complete Profile clicked!')}
            tooltipText="Enhance your experience by completing your profile"
            icon="🚀"
            index={2}
          />
          
          <DashboardCard
            title="Trending Now"
            description="See what's popular across the platform right now."
            buttonText="View Trends"
            buttonAction={() => alert('View Trends clicked!')}
            tooltipText="Discover the most popular content right now"
            icon="📈"
            index={3}
          />
        </section>
      )}
    </div>
  );
};

export default GeneralUserDashboard;